module.exports = __webpack_public_path__ + "static/media/get-started-en.06eaccc1.png";